import { Box, Button, ScrollArea, Table } from '@mantine/core';
import { IconPencilPlus } from '@tabler/icons-react';
import { useParams } from 'react-router-dom';
import { NoDataFoundMessage } from '../../components/DataTable';
import { LoadingRows } from '../../components/LoadingRows';
import { PageHeader } from '../../components/PageHeader';
import { Paper } from '../../components/Paper';
import { Title } from '../../components/Title';
import { useModal } from '../../hooks/useModal';
import {
	plainTableDefaults,
	useResponsiveSpace,
} from '../../hooks/useResponsiveSpace';
import { whiteIconButtonStyle } from '../../theme/styling/buttonStyling';
import { defaultIconStyle } from '../../theme/styling/iconStyling';
import { query } from '../../util/api/query';
import { BranchRow } from './components/BranchRow';
import { NewBranchModal } from './components/NewBranchModal';
import type { BranchDto } from './types/BranchTypes';
import { KeyedRow } from '../../components/KeyedRow';

export function Branches() {
	const { organisation } = useParams();
	const branchesQuery = query<BranchDto[]>(`${organisation}/branches`);

	const newModal = useModal();

	const responsiveHeight = useResponsiveSpace(plainTableDefaults);

	return (
		<>
			<NewBranchModal
				close={newModal.close}
				opened={newModal.isOpen}
				refreshTable={() => {
					branchesQuery.remove();
					branchesQuery.refetch();
				}}
			/>
			<PageHeader title={'Branches'} hideFiltering>
				<Button
					{...whiteIconButtonStyle}
					onClick={() => newModal.open()}
					data-cy={'create-iconButton'}
				>
					<IconPencilPlus {...defaultIconStyle} />
				</Button>
			</PageHeader>
			<Paper withPadding>
				<ScrollArea w={'100%'} h={responsiveHeight}>
					<Table stickyHeader striped>
						<Table.Thead>
							<KeyedRow>
								<Table.Th miw={145}>
									<Title label={'Name'} />
								</Table.Th>
								<Table.Th>
									<Title label={'Street'} />
								</Table.Th>
								<Table.Th>
									<Title label={'Area'} />
								</Table.Th>
								<Table.Th>
									<Title label={'Town'} />
								</Table.Th>
								<Table.Th>
									<Title label={'County'} />
								</Table.Th>
								<Table.Th>
									<Title label={'Post Code'} />
								</Table.Th>
								<Table.Th>
									<Title label={'Telephone No.'} />
								</Table.Th>
								<Table.Th>
									<Title label={'Email'} />
								</Table.Th>

								<Table.Th />
							</KeyedRow>
						</Table.Thead>
						<Table.Tbody>
							{branchesQuery.data?.value ? (
								<>
									{branchesQuery.data?.value.map((branch) => {
										return (
											<BranchRow
												key={branch.branchId}
												initialBranch={branch}
												refreshTable={() => {
													branchesQuery.remove();
													branchesQuery.refetch();
												}}
											/>
										);
									})}
								</>
							) : (
								<LoadingRows rows={20} columnSpan={10} />
							)}
						</Table.Tbody>
					</Table>
					<Box w={'100%'}>
						{branchesQuery.data?.value?.length === 0 && <NoDataFoundMessage />}
					</Box>
				</ScrollArea>
			</Paper>
		</>
	);
}
